import { render } from "./IssuesTable.vue?vue&type=template&id=483cc09c&scoped=true"
import script from "./IssuesTable.vue?vue&type=script&lang=js"
export * from "./IssuesTable.vue?vue&type=script&lang=js"

import "./IssuesTable.vue?vue&type=style&index=0&id=483cc09c&lang=scss&scoped=true"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483cc09c"]])

export default __exports__